<template>

    <div class="card mb-3 mb-lg-5">

        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-sm-6">

                    <inertia-link :href="route('suppliers.show', group.supplier)">
                        <div class="text-dark">
                            {{ __('Verkauf & Versand durch') }}
                        </div>
                        <div class="mt-2">
                            <img class="" :src="group.supplier.logo" alt="" style="max-height: 40px; width: auto;" v-if="group.supplier.logo" />
                            <div v-else class="h3">
                                {{ group.supplier.name }}
                            </div>
                        </div>
                    </inertia-link>

                    <div class="mt-2 small">
                        <a :href="group.supplier.terms_url" class="" target="_blank" v-if="group.supplier.terms_url">
                            <i class="bi bi-box-arrow-up-right"></i>
                            {{ __('AGB des Lieferanten') }}
                        </a>
                    </div>

                </div>
                <div class="col-sm-6 text-sm-end">
                    <div>
                        <div>
                            {{ __('Summe') }}
                        </div>
                        <div class="mt-0 h3">
                            {{ group.subtotal | localizeAmount }}
                        </div>
                    </div>

                    <div class="mt-2 text-warning" v-if="group.delivery_from == null">
                        {{ __('Noch keine Versandoptionen konfiguriert.') }}
                    </div>
                    <div class="mt-2 text-success fw-bold" v-else-if="group.delivery_from == 0">
                        {{ __('Versandkostenfrei') }}
                    </div>
                    <div class="mt-2 fw-bold" v-else>
                        {{ __('Versand ab :amount', {amount: $options.filters.localizeAmount(group.delivery_from)}) }}
                    </div>

                    <div class="text-danger fw-bold small" v-if="group.amount_needed_for_free_delivery">
                        {{ __('Noch :amount für kostenfreien Versand', {amount: $options.filters.localizeAmount(group.amount_needed_for_free_delivery)}) }}
                    </div>

                </div>
            </div>

        </div>

        <div class="card-body">

            <div class="pb-3 d-none d-md-block border-bottom">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-4">{{ __('Produkt') }}</div>
                    <div class="col-1">{{ __('Einzelpreis') }}</div>
                    <div class="col-2">{{ __('Anzahl') }}</div>
                    <div class="col-2">{{ __('Gesamtpreis') }}</div>
                    <div class="col-1"></div>
                </div>
            </div>

            <div class="py-4" v-for="cartItem in group.cart_items" :key="cartItem.id">

                <div class="row align-items-md-center g-4">

                    <div class="col-4 col-md-2 text-center">
                        <inertia-link :href="cartItem.product.permalink" v-if="cartItem.product_available">
                            <img class="img-fluid thumbnail" :src="cartItem.product.main_image_url" alt="" loading="lazy">
                        </inertia-link>
                    </div>
                    <div class="col-8 col-md-4">
                        <h5>
                            <inertia-link :href="cartItem.product.permalink" class="link-dark" v-if="cartItem.product_available">
                                {{ cartItem.product_name }}
                            </inertia-link>
                            <div v-else>
                                {{ cartItem.product_name }}
                            </div>
                        </h5>
                        <div class="small">
                            {{ __('Lieferanten-Artikelnr.: :number', {number: cartItem.supplier_pid}) }}
                            <!--                            <template v-if="cartItem.product_available">
                                                            &nbsp;&nbsp;
                                                            <span class="text-nowrap">
                                                                {{ __('Marktplatz-Artikelnr. :number', {number: cartItem.product.sku}) }}
                                                            </span>
                                                        </template>-->
                        </div>

                        <template v-if="cartItem.product_available">

                            <tax-info :product="cartItem.product" />
                            <delivery-info :product="cartItem.product" />

                            <!--@todo hide if already on watchlist...-->
                            <button
                                class="btn btn-sm btn-outline-secondary mt-2"
                                type="button"
                                @click="moveCartItemToWatchlist(cartItem.product)"
                                >
                                <i class="bi bi-pin-angle"></i>
                                {{ __('In Merkliste verschieben') }}
                            </button>
                            
                        </template>

                    </div>
                    <div class="col-6 col-md-1">
                        <div class="">
                            <span class="d-inline d-sm-none">
                                {{ __('Einzelpreis') }}
                            </span>
                            {{ cartItem.price | localizeAmount }}
                            <div class="small text-secondary text-nowrap" v-if="cartItem.price_quantity > 1">
                                {{ __('je :quantity Stck.', {quantity: cartItem.price_quantity}) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-md-2">
                        <quantity 
                            v-model.number="cartItem.quantity"
                            :min="cartItem.product.quantity_min"
                            :max="cartItem.product.quantity_max"
                            :interval="cartItem.product.quantity_interval"
                            v-if="cartItem.product_available"
                            />
                        <div class="text-danger" v-else>
                            {{ __('Das Produkt ist aktuell nicht verfügbar.') }}
                        </div>
                    </div>
                    <div class="col-6 col-md-1">
                        <div class="">
                            <span class="d-inline d-sm-none">
                                {{ __('Gesamtpreis') }}
                            </span>
                            {{ cartItem.total_price | localizeAmount }}
                        </div>
                    </div>
                    <div class="col-6 col-md-2 text-md-end">
                        <button
                            @click="deleteCartItem(cartItem.id)"
                            type="button"
                            class="btn btn-lg btn-outline-danger">
                            <i class="bi bi-x-lg"></i>
                            {{ __('Entfernen') }}
                        </button>
                    </div>
                </div>

            </div>

        </div>
        <div class="card-footer">
            <div class="text-end">
                <button 
                    type="submit"
                    class="btn btn-lg btn-outline-primary flex-grow-1 flex-md-grow-0" 
                    :disabled="form.processing" 
                    v-if="form.isDirty"
                    >
                    <i class="bi bi-arrow-clockwise"></i>
                    {{ __('Aktualisieren') }}
                </button>
                <template v-else>
                    <template v-if="$page.props.auth.user.can.checkout">
                        <inertia-link 
                            :href="route('checkout.index', {supplier_id: group.supplier.id})" 
                            class="btn btn-lg btn-secondary flex-grow-1 flex-md-grow-0"
                            >
                            <!--<i class="bi bi-cart2 me-2"></i>-->
                            <span class="" v-html="__('Bestellen <u><b>nur</b></u> bei :supplier', {supplier: group.supplier.name})">
                            </span>
                        </inertia-link>
                        <div class="mt-2 small">
                            {{ __('Sie können Ihre Bestellung im nächsten Schritt noch einmal überprüfen.') }}
                        </div>
                    </template>
                    <template v-else>
                        {{ __('Sie haben keine Berechtigung für weitere Schritte.') }}
                    </template>
                </template>
            </div>
        </div>
    </div>

</template>


<script>

    import Quantity from '@/shared/Quantity';
    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';
    import RadioInput from '@/shared/Inputs/RadioInput';
    import RadiosInput from '@/shared/Inputs/RadiosInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';

    export default {
        props: [
            'form',
            'group',
        ],
        data() {
            return {
            }
        },
        components: {
            Quantity,
            TaxInfo,
            DeliveryInfo,
            RadioInput,
            RadiosInput,
            TextareaInput,
        },
        computed: {

        },
        methods: {
            moveCartItemToWatchlist(product) {
                this.$inertia.post(route('watchlist.add-item', product), {remove_from_cart: 1}, {preserveScroll: false, preserveState: false});
            },
            deleteCartItem(id) {
                this.$inertia.delete(route('cart.remove-item', id), {preserveScroll: false, preserveState: false});
            },
        },
    }
</script>